import React from 'react';

type Props = {
  children: React.ReactNode;
  className?: string;
};

/**
 * Horizontal flex row used as the field container in OrderForm. Children
 * align center; consistent vertical padding and spacing.
 *
 * Mirrors `primitiveStyles.field` from the prototype:
 *   display: flex; align-items: center; gap: 8; padding: 3px 0; min-height: 26
 */
const Row: React.FC<Props> = ({ children, className }) => (
  <div
    className={
      'flex items-center gap-2 py-[0.1875rem] min-h-[1.625rem] ' + (className ?? '')
    }
  >
    {children}
  </div>
);

export default Row;
